/** True when pathname is exactly href or a nested route under href (e.g. /projects/123). */
export function isNavHrefActive(pathname, href) {
  if (!href || href === "#" || href.startsWith("#")) return false;
  const p = pathname.replace(/\/$/, "") || "/";
  const h = href.replace(/\/$/, "") || "/";
  if (p === h) return true;
  return p.startsWith(`${h}/`);
}
